import { render, staticRenderFns } from "./UvvChecks.vue?vue&type=template&id=612cf7de&"
import script from "./UvvChecks.vue?vue&type=script&lang=js&"
export * from "./UvvChecks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports